import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from "@angular/core";

// this needs to coexist along ClDropDirective until every component using it is migrated from angularJS
@Directive({
    selector: '[clDragElement]'
})
export class ClDragDirective implements OnInit {
    @Input() clDragElement: boolean;

    @Output() clDrag = new EventEmitter();
    @Output() clEnd = new EventEmitter();
    @Output() clLeave = new EventEmitter();
    @Output() clOver = new EventEmitter();


    constructor(private hostElementRef: ElementRef, private renderer: Renderer2) {
    }

    ngOnInit() {
        if (this.clDragElement === false) {
            this.renderer.setAttribute(this.hostElementRef.nativeElement, 'draggable', null);
            if (!this.hostElementRef.nativeElement.getAttribute('title')) {
                this.renderer.setAttribute(this.hostElementRef.nativeElement, 'title', 'You cannot drag this!');
            }
            return;
        }

        this.renderer.setAttribute(this.hostElementRef.nativeElement, 'draggable', 'true');
    }

    @HostListener('dragstart', ['$event'])
    dragStart($event) {
        this.clDrag.emit($event);
    }

    @HostListener('dragend', ['$event'])
    dragEnd($event) {
        this.clEnd.emit($event);
    }

    @HostListener('dragover', ['$event'])
    dragOver($event) {
        this.clOver.emit($event);
    }

    @HostListener('dragleave', ['$event'])
    dragLeave($event) {
        this.clLeave.emit($event);
    }
}